import { useSelector as useReduxSelector } from 'react-redux'
import type { UserState, UserRootState } from './types'
import { defaultState } from './reducer'

export const useSelector = (): UserState =>
  useReduxSelector(({ userForm = defaultState }: UserRootState) => userForm)

export default useSelector
